import { cleanFullAddress, PropertyAddress } from '@urbanx/agx-ui-components'
import { AuthContext } from '@urbanx/agx.auth.client'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { PageLayout } from 'layout'
import { useContext } from 'react'
import { Outlet } from 'react-router-dom'

const Finance = () => {
  const { userAccount } = useContext(AuthContext)
  const { agency: selectedAgency } = useSelectedAgency()
  const { campaign: selectedCampaign } = useSelectedCampaign()

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={selectedAgency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(
        selectedCampaign?.address as unknown as PropertyAddress
      )}`}
      isCampaignsSection={true}
    >
      <Outlet />
    </PageLayout>
  )
}

export default Finance
